/**
 * Ein Knopf „Gmail öffnen" nach der Registrierung (Entwurf „99takes Signup
 * Politur", 12.10.2026). Nur für Anbieter, die man an der Domain sicher
 * erkennt; eine Firmenadresse kann überall liegen, dann gibt es keinen Knopf.
 *
 * Gmail öffnet gleich die Suche nach unserem Absender, die übrigen den
 * Posteingang: eine Suche per Link bieten sie nicht verlässlich an.
 */

export interface Webmail { name: string; url: string }

const ANBIETER: Array<{ domains: string[]; name: string; url: (absender: string) => string }> = [
  { domains: ['gmail.com', 'googlemail.com'], name: 'Gmail', url: a => `https://mail.google.com/mail/u/0/#search/${encodeURIComponent(`from:${a} in:anywhere`)}` },
  {
    domains: ['outlook.com', 'outlook.de', 'hotmail.com', 'hotmail.de', 'live.com', 'live.de', 'msn.com'],
    name: 'Outlook', url: () => 'https://outlook.live.com/mail/',
  },
  { domains: ['gmx.de', 'gmx.net', 'gmx.at', 'gmx.ch'], name: 'GMX', url: () => 'https://www.gmx.net/' },
  { domains: ['web.de'], name: 'WEB.DE', url: () => 'https://web.de/' },
  { domains: ['t-online.de'], name: 't-online', url: () => 'https://email.t-online.de/' },
  { domains: ['icloud.com', 'me.com', 'mac.com'], name: 'iCloud Mail', url: () => 'https://www.icloud.com/mail' },
  { domains: ['yahoo.com', 'yahoo.de'], name: 'Yahoo Mail', url: () => 'https://mail.yahoo.com/' },
];

export function webmailFuer(email: string, absender: string): Webmail | null {
  const domain = email.trim().toLowerCase().split('@')[1];
  if (!domain) return null;
  const a = ANBIETER.find(x => x.domains.includes(domain));
  return a ? { name: a.name, url: a.url(absender) } : null;
}
